import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ExternalUnprocessClaimsComponent} from './external-unprocess-claims/external-unprocess-claims.component';
import {ExternalProcessedClaimsComponent} from './external-processed-claims/external-processed-claims.component';
import {ExternalPaymentsComponent} from './external-payments/external-payments.component';
import {ExternalDenialsAuditsComponent} from './external-denials-audits/external-denials-audits.component';
import {ExternalDenialsComponent} from './external-denials/external-denials.component';

const routes: Routes = [
  { path: 'epcr', loadChildren: 'app/pages/billing-epcr/billing-epcr.module#BillingEpcrModule' },
  {
    path: 'providers',
        children: [
          { path: 'unprocess-claims', component: ExternalUnprocessClaimsComponent, data: { title: 'Unprocessed Claims' } },
          { path: 'processed-claims', component: ExternalProcessedClaimsComponent, data: { title: 'Processed Claims'} },
          { path: 'pay-ments', component: ExternalPaymentsComponent, data: { title: 'Payments'} },
          { path: 'denials-audits', component: ExternalDenialsAuditsComponent, data: { title: 'Denials / Audits'} },
          { path: 'provider-denails', component: ExternalDenialsComponent, data: { title: 'Provider Denials'} },
        ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ExternalBillingRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/external-billing/external-billing-routing.module.ts